'use client';
import React from 'react';
import styles from './AvailabilitySelectionSkeleton.module.css';
import BookingInfoSkeleton from './BookingInfoSkeleton.component';

interface AvailabilitySelectionSkeletonProps {
  numberOfDays?: number;
}

const AvailabilitySelectionSkeleton = ({
  numberOfDays = 3,
}: AvailabilitySelectionSkeletonProps) => {
  return (
    <div className={styles.main_container}>
      {/* Booking Info Skeleton */}
      <BookingInfoSkeleton />

      {/* Availability Slots Skeleton */}
      <div className={styles.availability_container}>
        {Array.from({ length: numberOfDays }).map((_, dayIndex) => (
          <div key={dayIndex} className={styles.availability_day}>
            {/* Skeleton date title */}
            <div className={styles.skeleton_title}></div>

            {/* Skeleton time slots */}
            <div className={styles.skeleton_availability}>
              {Array.from({ length: 3 }).map((_, slotIndex) => (
                <div key={slotIndex} className={styles.skeleton_slot}>
                  <div className={styles.skeleton_slot_text}></div>
                </div>
              ))}
            </div>

            {/* Skeleton "More times" button */}
            <div className={styles.skeleton_more_times_button}></div>
          </div>
        ))}

        {/* Skeleton pagination buttons */}
        <div className={styles.skeleton_pagination_container}>
          <div className={styles.skeleton_pagination_btn}></div>
          <div className={styles.skeleton_pagination_btn}></div>
        </div>
      </div>
    </div>
  );
};

export default AvailabilitySelectionSkeleton;
